import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import AdSense from 'react-adsense';
import { Cookies } from '../index.js';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { animateScroll as scroll } from 'react-scroll';
import { RingLoader } from "react-spinners";
import { isMobile } from 'react-device-detect';
import Select from 'react-select';
import { alert_error, alert_success } from '../AppContext';
import { isLocalHost } from '../shared/host_utils.js';
function Rutgonlink() {
    const navigate = useNavigate();
    const recaptchaRef = React.createRef();
    const [inputmota, setinputmotat] = useState('');
    const [taikhoan, settaikhoan] = useState('');
    const [balance, setbalance] = useState('');
    const [social, setSocial] = useState('');
    const [nutorder, setnutorder] = useState('Xác nhận captcha');
    const [thanhcong2, setthanhcong2] = useState('');
    const [nutxuly, setnutxuly] = useState(1);
    const [service, setservice] = useState('');
    const [amount, setamount] = useState('');
    const [captcha, setcaptcha] = useState('');
    const [content, setcontent] = useState('');
    const [hanmuc, sethanmuc] = useState('');
    const [chietkhau, setchietkhau] = useState('');
    const [options, setoptions] = useState([
        {
            id: '', stt: '', name: 'Chọn 1 kiểu rút tiền',
            money: '', status: 'show', content: '', servicecode: ''
        }
    ]);
    const [options2, setoptions2] = useState([
        {
            id: '1', stt: 'GARENA', name: 'GARENA',
            value: 'Garena', status: 'show', content: ''
        },
        {
            id: '2', stt: 'GATE', name: 'GATE',
            value: 'Gate', status: 'show', content: ''
        },
        {
            id: '3', stt: 'ZING', name: 'ZING',
            value: 'Zing', status: 'show', content: ''
        },
        {
            id: '4', stt: 'VCOIN', name: 'VCOIN',
            value: 'Vcoin', status: 'show', content: ''
        },
        {
            id: '5', stt: 'APPOTA', name: 'APPOTA',
            value: 'Appota', status: 'show', content: ''
        },
        {
            id: '6', stt: 'SOHACOIN', name: 'SOHACOIN',
            value: 'Sohacoin', status: 'show', content: ''
        },
        {
            id: '7', stt: 'VIETTEL', name: 'VIETTEL',
            value: 'Viettel', status: 'show', content: ''
        },
        {
            id: '8', stt: 'VINAPHONE', name: 'VINAPHONE',
            value: 'Vina', status: 'show', content: ''
        },
        {
            id: '9', stt: 'MOBIFONE', name: 'MOBIFONE',
            value: 'Mobi', status: 'show', content: ''
        },
        {
            id: '10', stt: 'VNMOBI', name: 'VNMOBI',
            value: 'Vnmobile', status: 'show', content: ''
        },
        {
            id: '11', stt: 'SCOIN', name: 'SCOIN',
            value: 'Scoin', status: 'show', content: ''
        },
    ]);

    const [options3, setoptions3] = useState([
        {
            id: '1', stt: '', name: 'Thẻ 10.000 (10K)',
            value: '10000', status: 'show', content: '', servicecode: ''
        },
        // {
        //     id: '2', stt: '', name: 'Thẻ 20.000 (20K)',
        //     value: '20000', status: 'show', content: '', servicecode: ''
        // }
    ]);
    function gopdulieu(response) {
        const arr1 = [
            {
                id: '', stt: '', name: 'Chọn 1 kiểu lấy thẻ',
                money: '', status: 'show', content: '', servicecode: ''
            }
        ];

        const arr2 = response.data;

        setoptions(arr1.concat(arr2));

    }
    ;
    const handleRecaptchaChange = (value) => {
        console.log(value);
        const maxLength = 200;

        if (value.length > maxLength) {
            setcaptcha(value);
            setnutxuly(0);
            setnutorder('✔️ Click to Confirm');

        }
        else {
            setnutorder('Đã xảy ra lỗi tải lại trang nhé');
        }
    };
    function laydulieu() {
        axios
            .post('https://hust.media/getservice/service.php', {
                category: 'buycard'
            })
            .then(response => gopdulieu(response))
            .catch(error => console.log(error))
    };
    function thongtintk() {
        // setnutxuly(0);
        const domain = window.location.hostname;
        const apikey = Cookies.get('apikey');
        axios
            .get('https://hust.media/jop/pay/checktk.php?apikey=' + apikey + '&chedo=buycard' + '&domain=' + domain)
            .then(response => testFunction(response))
            .catch(error => alert_error(error))
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        setnutxuly(0);
        if (status == 0) {
            setnutorder('đặt tiếp luôn nào')
            alert_error(info.message);
            window.grecaptcha.reset();
        }
        else if (status == 1) {
            setnutorder('Thành công')
            alert_success(info.message);
            setthanhcong2(info.amount);
        }
        else if (status == 5) {
            sethanmuc(info.hanmuc);
            setchietkhau(info.chietkhau);
            settaikhoan(info.taikhoan);
            window.grecaptcha.reset();
            setbalance(info.balance);
        }
        else {
            setnutorder('đã xảy ra lỗi vui lòng liên hệ admin')
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    const scrollToBottom = () => {
        scroll.scrollToBottom({ duration: 200 }); // Cuộn xuống hết trang trong 800ms
    };
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get('apikey');
        event.preventDefault();

        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!social || !service) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        axios
            .post('https://hust.media/jop/pay/bank.php', {
                amount: amount,
                apikey: apikey,
                service: service,
                captcha: captcha,
                chedo: 'buycard',
                social: social
            })
            .then(response => (testFunction(response)))
            .catch(error => (alert_error(error),
                setnutxuly(0),
                window.grecaptcha.reset()))

    }

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    const [isOpen, setIsOpen] = useState(true);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };
    const handleFocus3 = () => {
        setIsOpen3(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleBlur2 = () => {
        setIsOpen2(false);
    };
    const handleBlur3 = () => {
        setIsOpen3(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };
    const handleMenuOpen3 = () => {
        setIsOpen3(true);
    };
    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        const selectedOptionpro = selectedOption.value;
        setservice(selectedOptionpro);
        const selectedOptionok = options.find((option) => option.id == selectedOptionpro);
        setcontent(selectedOptionok);
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    const handleOptionChange2 = (selectedOption) => {
        setIsOpen2(false);
        const selectedOptionpro = selectedOption.value;
        const selectedOptionok = options2.find((option) => option.id == selectedOptionpro);
        setSocial(selectedOptionok.value);
    }
    const handleOptionChange3 = (selectedOption) => {
        setIsOpen3(false);
        const selectedOptionpro = selectedOption.value;
        const selectedOptionok = options3.find((option) => option.id == selectedOptionpro);
        // alert_success(selectedOptionok.value);
        setamount(selectedOptionok.value);
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    const [type_user, settype_user] = useState('');
    useEffect(() => {
        const Type_user = Cookies.get('type_user');
        if (Type_user != 'personal') {
            if (isMobile || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
                const userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android")
                    || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
                    laydulieu();
                    thongtintk();
                } else {
                    alert_error('Vui lòng tải app để sử dụng tính năng này');
                    setTimeout(() => {
                        navigate('/reactapp/thankiu');
                    }, 700);
                }
            }
            else {
                laydulieu();
                thongtintk();
            }
        }
        else {
            settype_user(Type_user);
            laydulieu();
            thongtintk();
        }
    }, []);


    return (
        <>
            <Helmet>
                <title> Rút tiền qua thẻ cáo</title>
            </Helmet>
            {window.location.hostname != 'tecom.pro' && (
                <Helmet>
                    <script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script>
                    {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
                    <script data-cfasync="false" type="text/javascript" src="//hhbypdoecp.com/lv/esnk/1978451/code.js" async id="__clb-1978451"></script>
                </Helmet>
            )}
            <div>
                <div className="mt-0 mx-2">
                    {type_user != 'personal' && (<>
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="5828045161"
                            style={{ display: 'block' }}
                            format="auto"
                            responsive="true"
                        />
                    </>)}

                    <form className="add-form">

                        <div className="form-control">
                            <div className="row align-items-center">
                                <div className="col mb-0">
                                    <div className="col text-left">
                                        <label>Chọn kiểu lấy thẻ</label>
                                    </div>
                                </div>
                                <div className="col text-right">

                                    <div onClick={scrollToBottom} className="btn btn-sm">Kéo xuống để xem hạn mức</div>

                                </div>

                            </div>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus}
                                options={options.map((option) => ({
                                    value: option.id,
                                    label: `${option.name} ${option.money}`
                                }))}
                                menuIsOpen={isOpen}
                                onBlur={handleBlur}
                                onMenuOpen={handleMenuOpen}
                                onChange={handleOptionChange}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            >


                            </Select>
                            <div className="row align-items-center">
                                <div className="col mb-0">
                                    <div className="col text-left">
                                        <label>Chọn nhà mạng</label>
                                    </div>
                                </div>
                                <div className="col text-right">

                                    <a href="/reactapp/cash_diary?webappmode=showadview" className="btn btn-sm btn-primary">Nhật ký nhận thẻ</a>

                                </div>
                            </div>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus2}
                                options={options2.map((option) => ({
                                    value: option.id,
                                    label: `${option.name}`
                                }))}
                                menuIsOpen={isOpen2}
                                onBlur={handleBlur2}
                                onMenuOpen={handleMenuOpen2}
                                onChange={handleOptionChange2}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            >

                            </Select>
                            <div className="row align-items-center">
                                <div className="col mb-0">
                                    <div className="col text-left">
                                        <label>Chọn mệnh giá</label>
                                    </div>
                                </div>
                            </div>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus3}
                                options={options3.map((option) => ({
                                    value: option.id,
                                    label: `${option.name}`
                                }))}
                                menuIsOpen={isOpen3}
                                onBlur={handleBlur3}
                                onMenuOpen={handleMenuOpen3}
                                onChange={handleOptionChange3}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            >

                            </Select>

                            <div className="row align-items-center">

                                {chietkhau && (<div className="col text-left">
                                    <div className="text-sm">
                                        Chiết khấu: {chietkhau}%
                                    </div>
                                </div>
                                )}



                                {amount && content.money && chietkhau && (
                                    <div className="col text-right">
                                        <div className="text-base">
                                            Tổng: {(amount * content.money * (100 - chietkhau) / 100).toFixed(0)} Coins
                                        </div>
                                    </div>
                                )}


                            </div>

                            <div className="max-h-16">
                                <div className="cards">
                                    <AdSense.Google
                                        client="ca-pub-4574266110812955"
                                        slot="1627514116"
                                        style={{ display: 'block', height: 50 }}
                                        format=""
                                    /> </div>
                            </div>

                        </div>

                        <ReCAPTCHA
                            className="flex justify-center items-center "
                            ref={recaptchaRef}
                            sitekey="6LfHUSYeAAAAAI8X84A9EXqbovZpFJyYmhiveXYD"
                            onChange={handleRecaptchaChange}
                        />
                        {/* <div className='mt-1 mb-0 text-xs'>    {taikhoan}</div> */}


                        <button disabled={nutxuly == 1} onClick={handleSubmit}
                            className='mt-2 mb-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
                            <div className='flex items-center justify-between flex-1'>
                                {nutxuly == 1 &&
                                    <div className="spinner-border" role="status">

                                    </div>}


                                <span className='text-lg font-medium text-white'>
                                    {nutorder} </span>
                                <div className="text-xl">
                                    {'\u27A4'}
                                </div>
                            </div>
                        </button>

                        <div className='mt-1 mb-0 text-base'>Hạn mức không mất phí {hanmuc}</div>
                        <div className='mt-0 text-sm'>nếu báo hạn mức ko đủ vui lòng chọn cho thành viên
                        </div>
                        <div className='mt-0 text-sm'>Số dư tài khoản thẻ cào của app: {balance} săn ngay khi có cơ hội =))
                        </div>
                        <div className='mt-0 text-sm'>Mua tối đa 1 lần mỗi ngày
                        </div>
                        <a target="_blank" href="/shop/content/blog_posts/freefltiktok/36"> Ấn đây để xem cách tính hạn mức rút tiền </a>
                    </form>





                </div>

                <br></br>
            </div>    </>
    )
}

export default Rutgonlink;
